module.exports = __webpack_public_path__ + "img/otp-icon.6df78a68.svg";